<template>
  <div class="baseSetting-main">
    <div class="title">
      <span class="parent">系统设置 / </span>
      <span>学习报告设置</span>
    </div>
    <div class="container">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="学习报告设置" name="second">
          <div class="share-container">
            <div class="share-title"><el-divider direction="vertical" style="width:5px;background:blue"></el-divider> 学习报告分享设置</div>
            <div class="tip">
              <i class="el-icon-warning" style="fontSize:22px;color:#1978FF"></i>
              <span>您可以设置公众号、小程序分享文案</span>
            </div>
            <div class="share-content">
              <div class="area-box">
                <div class="left">
                  <img style="width:50px;height:50px;" fit="" src="../../../assets/image/starCoin/reportHead@2x.png">
                </div>
                <div class="right">
                  <div class="right-box">
                    <!-- <el-input type="textarea" v-model="shareContent.text" placeholder="请输入分享文案"></el-input> -->
                    <div class="editor-container">
                      <div ref="editor" contenteditable="true" @input="handleInput" @keydown="handleKeydown" class="editor" placeholder="请输入内容..." :style="{ maxHeight: '200px', overflowY: 'auto' }"></div>
                      <!-- <div class="word-count">{{copyLength}} / {{maxLength}}</div> -->
                      <div class="word-count">建议25字，超过字数显示...</div>
                    </div>
                    <!-- <el-image style="width:120px;height:120px;" src="https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg"></el-image> -->
                    <!-- <img style="width:120px;height:120px;object-fit:contain" fit="" src="../../../assets/image/starCoin/reportPlaceholder@2x.png"> -->
                  </div>
                </div>
              </div>
              <div class="tag-container">
                <!-- :style="{ backgroundColor: tagColors[index % tagColors.length] }" -->
                <span v-for="(tag, index) in tags" :key="index" @click="insertTag(tag)" class="tag">
                  <strong><i class="el-icon-plus"></i></strong> {{ tag }}
                </span>
              </div>

            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div class="clue-box" v-if="activeName ==='second'">
        <div class="share-title"><el-divider direction="vertical" style="width:5px;background:blue"></el-divider> 获取线索方式</div>
        <div class="radio-box">
          <el-radio-group v-model="shareContent.culeType" @input.native="handleChangeFormType">
            <el-radio :label="1">表单获取线索</el-radio>
            <el-radio :label="2">二维码获取线索</el-radio>
          </el-radio-group>
        </div>
        <div class="clue-qrcode" v-if="shareContent.culeType === 2">
          <!-- qrCodeFileList -->
          <el-upload ref="refUpload" action="" :http-request="uploadFile" :on-remove="handleRemove" :on-change="handleChangeFile" :auto-upload="false" :limit="1" :on-exceed="handleExceed" :file-list="shareContent.qrCodeFileList" list-type="picture" style="width: 400px">
            <el-button size="small" plain type="primary" icon="el-icon-upload">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
          </el-upload>
        </div>
      </div>
      <div class="share-btns" v-if="activeName ==='second'">
        <el-button plain size="medium" style="backgroundColor:#fff;color:#2488ef" @click="getEduCampusShareReportDetail">重 置</el-button>
        <el-button type="primary" size="medium" @click="updateEduCampusShareReportEdit">确定</el-button>
      </div>
    </div>
  </div>
</template>
<script>
// 引入资源
import uploadFile from '@/config/uploadFile'
// api
import {
  api_eduCampusShareReportDetail,
  api_eduCampusShareReportEdit
} from '@/api/javaApi'

export default {
  name: 'baseLearningReportSettingVue',
  data() {
    return {
      activeName: 'second',
      shareContent: {
        culeType: 1,
        qrCodeFileList: []
      },
      uploadFileTime: false,

      tags: ['机构名称', '学生姓名', '课程名称', '学编程天数'],
      tagColors: ['#FFD700', '#ADD8E6', '#90EE90', '#FFA07A', '#FFB6C1'],
      selectionStart: 0,
      selectionEnd: 0,
      shareText: '',
      copyLength: 0,
      maxLength: 30
    }
  },
  mounted() {
    this.getEduCampusShareReportDetail();
    window.hendleClearTag = this.hendleClearTag
  },
  methods: {
    handleChangeFormType() {
      // setTimeout(() => {
      //   this.updateEduCampusShareReportEdit();
      // }, 200)
    },
    getEduCampusShareReportDetail() {
      api_eduCampusShareReportDetail({
        id: this.$store.state.user.selected_schools[0]
      }).then(res => {
        if (res) {
          window.log.tables(res)
          const editor = this.$refs.editor
          console.log(editor)
          this.shareText = res.copy;
          editor.innerHTML = this.shareText;
          this.copyLength = editor.innerText.length;
          this.shareContent.culeType = res.shareReportClueType;
          if (res.shareReportQrCodeImg) {
            this.shareContent.qrCodeFileList = [{ url: res.shareReportQrCodeImg }];
          }
        } else {
          console.log('没有内容')
        }
      })
    },
    countOccurrences(str, arr) {
      let totalCount = 0;

      // 定义一个辅助函数用于转义正则表达式的特殊字符
      function escapeRegExp(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& 表示整个匹配的结果
      }

      // 遍历数组中的每个词语
      arr.forEach(word => {
        const newWord = `[${word}]`
        // 创建一个正则表达式，用于匹配目标词语。
        // 使用转义后的词语以确保正则表达式的正确性。
        const regex = new RegExp(`(${escapeRegExp(newWord)})`, 'g');

        // 使用 match 方法获取所有的匹配结果
        const matches = str.match(regex);

        // 如果没有找到任何匹配项，则该词语出现次数为 0；否则累加匹配项的数量
        totalCount += matches ? matches.length : 0;
      });

      return totalCount;
    },
    updateEduCampusShareReportEdit() {
      const overflowTag = this.countOccurrences(this.shareText, this.tags)
      console.log(overflowTag)
      if (overflowTag > 10) {
        return this.$message.error('标签最多只能出现十次')
      }
      if (!this.shareText) {
        return this.$message.warning('请输入分享文案')
      }
      if (this.shareContent.culeType === 2 && this.shareContent.qrCodeFileList.length === 0) {
        return this.$message.warning('请先上传二维码')
      }
      api_eduCampusShareReportEdit({
        eduCampusId: this.$store.state.user.selected_schools[0],
        shareReportClueType: this.shareContent.culeType,
        shareReportQrCodeImg: this.shareContent.qrCodeFileList[0] ? this.shareContent.qrCodeFileList[0].url : '',
        copy: this.shareText
      }).then(res => {
        window.log.tables(res)
        this.$message.success('保存成功')
        this.getEduCampusShareReportDetail()
      })
    },
    hendleClearTag(e) {
      console.log(e)
      const domTag = e.target.parentNode;
      domTag.remove()
    },
    insertTag(tag) {
      const editor = this.$refs.editor;
      editor.focus();
      const selection = document.getSelection();
      if (selection.type === 'None') {
        return false;
      }
      const range = selection.getRangeAt(0);
      const span = document.createElement('span');
      span.className = 'tag-inserted';
      span.tabIndex = '-1'
      span.setAttribute('contenteditable', false)
      span.textContent = `[${tag}]`;
      // const closeIcon = document.createElement('i');
      // closeIcon.className = 'el-icon-error'
      // closeIcon.style.fontSize = "14px"
      // closeIcon.style.color = "#f55300"
      // closeIcon.style.marginLeft = "4px"
      // closeIcon.style.cursor = 'pointer'
      // span.appendChild(closeIcon)
      // span.innerHTML += `]`;
      // span.innerHTML = `[${tag} <i onclick="hendleClearTag(event)" class="el-icon-error" style="color:#f55300;font-size:14px;margin-left:4px;cursor:pointer"></i>]`

      // let lastSpan = document.createElement('span')
      // lastSpan
      // console.log(lastSpan)
      // debugger
      range.deleteContents();
      range.insertNode(span);
      // range.insertNode(lastSpan);
      // Move the cursor after the inserted tag
      const newRange = document.createRange();
      newRange.setStartAfter(span);
      newRange.collapse(true);
      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(newRange);
      this.moveCursorToEndOfAdjacentElement()
      this.shareText = editor.innerHTML
    },
    handleInput(event) {
      const editor = event.target;
      // Ensure the total length does not exceed 50 characters
      // if (editor.innerHTML.length >= this.maxLength) {
      //   editor.innerHTML = editor.innerHTML.substring(0, this.maxLength)
      // }
      this.shareText = editor.innerHTML
      this.copyLength = editor.innerText.length;
      // if (this.copyLength>this.maxLength) {
      //   editor.innerHTML
      // }
      // let totalTextLength = editor.innerText.replace(/\s+/g, '').length;
      // if (totalTextLength > this.maxLength) {
      //   const lastChild = editor.lastChild;
      //   if (lastChild) {
      //     let currentText = lastChild.textContent || '';
      //     while (currentText && totalTextLength > this.maxLength) {
      //       currentText = currentText.slice(0, -1);
      //       lastChild.textContent = currentText;
      //       totalTextLength = editor.innerText.replace(/\s+/g, '').length;
      //     }
      //   }
      // }
    },
    handleKeydown(event) {
      const key = event.key;
      console.log(key)
      if (key === 'Backspace' || key === 'Delete') {
        const selection = window.getSelection();
        console.log(selection.rangeCount)
        const range = selection.getRangeAt(0);
        const startContainer = range.startContainer;
        console.log('startContainer:', startContainer)
        const endContainer = range.endContainer;
        console.log('startContainer.classList:', startContainer.classList)
        // if (startContainer.nodeType === 1 && startContainer.classList.contains('tag-inserted')) {
        //   event.preventDefault();
        // }
        if (startContainer.parentNode && startContainer.parentNode.classList.contains('tag-inserted')) {
          startContainer.parentNode.remove();
          event.preventDefault();
        } else if (endContainer.parentNode && endContainer.parentNode.classList.contains('tag-inserted')) {
          endContainer.parentNode.remove();
          event.preventDefault();
        }
      }
      // if (this.shareText.length > 30) {
      //   event.preventDefault();
      // }
    },
    moveCursorToEndOfAdjacentElement() {
      // 获取当前的选择信息
      const selection = window.getSelection();
      if (!selection.rangeCount) return;

      // 获取当前的range（即光标位置）
      let range = selection.getRangeAt(0);

      // 创建一个临时的range来帮助我们找到光标的左侧节点
      let tempRange = range.cloneRange();
      tempRange.setStart(range.startContainer, Math.max(0, range.startOffset - 1));
      tempRange.setEnd(range.startContainer, range.startOffset);
      // 获取光标左侧的节点
      let node = tempRange.startContainer;
      if (tempRange.startOffset > 0 && node.nodeType === Node.TEXT_NODE) {
        node = node.parentNode; // 如果是在文本节点内，检查其父节点
      }
      // 检查这个节点是否是我们想要的目标DOM元素
      if (node && node.nodeType === Node.ELEMENT_NODE) {
        // 找到了目标元素，创建一个新的range并将其放置在文本末尾
        let newRange = document.createRange();
        let textNode = node.lastChild;
        if (textNode && textNode.nodeType === Node.TEXT_NODE) {
          newRange.setStart(textNode, textNode.length);
          newRange.setEnd(textNode, textNode.length);

          // 移动光标到新的位置
          selection.removeAllRanges();
          selection.addRange(newRange);
        }
      }
    }
    ,
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // 分享学习报告设置二维码获取线索图
    uploadFile() { },

    handleExceed() {
      this.$message.warning('请删除原有文件,再重新上传')
    },
    handleRemove(file, fileList) {
      // this.form.imgupList = fileList
      console.log(fileList)
      this.removeFile(file)
    },
    removeFile(file) {
      // 使用 Element UI 的 remove 方法移除文件
      this.$refs.refUpload.clearFiles()
      this.shareContent.qrCodeFileList = this.shareContent.qrCodeFileList.filter((f) => f.uid !== file.uid)
    },
    async handleChangeFile(file, fileList) {
      const isLt500K = file.size / 1024 < 500;
      if (!isLt500K) {
        // this.fileList.pop()
        this.removeFile(file)
        // 上传的文件大小不能超过 500KB!
        return this.$message.warning('图片不符合规则，请重新上传！')
      } else {
        if (!this.uploadFileTime) {
          await this.uploadFileOss(fileList)
        }
      }
    },
    async uploadFileOss(list) {
      this.uploadFileTime = true
      await uploadFile(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          console.log(res)
          this.shareContent.qrCodeFileList = res
          this.uploadFileTime = false
        }
      )
    },
    /**end */
  },
}
</script>
<style scoped lang="scss">
.baseSetting-main {
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100% + 60px);
  padding: 10px;
  .title {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    height: 60px;
    padding-left: 20px;
    margin-bottom: 10px;
    background: #ffffff;
    font-size: 14px;
    box-shadow: 0px 0px 4px 0px #f0f4f5;
    border-radius: 5px;
    border: 1px solid #f4f5f9;
    span {
      vertical-align: middle;
      padding-top: 3px;
      &.parent {
        padding-top: 0;
        margin-right: 10px;
        font-size: 16px;
      }
    }
  }
  .container {
    flex: 1;
    // background-color: #fff;
    .el-tabs {
      padding: 10px 20px 20px;
      background-color: #fff;
      border-radius: 5px;
      margin-bottom: 20px;
    }
    .setting-prepare,
    .setting-ojRank,
    .setting-passwordHint {
      width: 100%;
      border: 1px solid #eee;
      border-radius: 5px;
      padding: 15px 15px;
      margin: 10px 0 20px;
      .setting-title {
        display: flex;
        align-items: center;
        padding-bottom: 15px;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        b {
          width: 3px;
          height: 14px;
          margin-right: 5px;
          background-color: #1978ff;
          border-radius: 30px;
        }
      }
      .setting-content {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        span {
          padding-right: 20px;
          font-size: 14px;
        }
        .el-switch /deep/ {
          .el-switch__label {
            span {
              font-size: 12px;
            }
          }
        }
      }
      .setting-tip {
        width: 100%;
        padding-top: 20px;
        color: #999;
        font-size: 12px;
      }
    }
    .share-container {
      padding: 20px 30px;
      border-radius: 5px;
      border: 1px solid #efefef;
      .share-title {
        display: flex;
        align-items: center;
        margin-bottom: 25px;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        /deep/ .el-divider {
          width: 3px;
          background-color: #1978ff;
        }
      }
      .tip {
        display: flex;
        align-items: center;
        width: 100%;
        height: 45px;
        padding: 0 15px;
        margin-bottom: 15px;
        background: #e8f2ff;
        border-radius: 2px;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
        span {
          padding-left: 20px;
        }
      }
      .share-content {
        max-width: 720px;
        padding: 25px 10px;
        background: #f4f5fb;
        border-radius: 10px;
        .area-box {
          display: flex;
          width: 100%;
          .left {
            flex-shrink: 0;
            margin-right: 15px;
            .el-image {
              background: #d8d8d8;
              border-radius: 3px;
            }
          }
          .right {
            position: relative;
            display: flex;
            // width: 100%;
            width: calc(100% - 65px);
            padding: 20px 20px 10px 20px;
            background: #fff;
            border-radius: 5px;
            // overflow: hidden;
            &::before {
              content: "";
              position: absolute;
              left: -6px;
              top: 18px;
              z-index: 1;
              display: inline-block;
              width: 15px;
              height: 15px;
              border-radius: 3px;
              background: #fff;
              transform: rotate(45deg) skew(-15deg, -15deg);
            }
            .right-box {
              width: 100%;
              display: flex;
              .editor-container {
                position: relative;
                flex: 1;
                padding: 10px 10px 22px;
                // margin-right: 20px;
                border: 1px dashed #ddd;
                border-radius: 10px;
                font-size: 16px;
                overflow: hidden;
                scrollbar-width: none;
                .editor {
                  min-height: 100px;
                  outline: none;
                  /deep/ .tag-inserted {
                    padding: 2px 5px;
                    margin-right: 2px;
                    border-radius: 4px;
                    color: #2488ef;
                  }
                }
                .word-count {
                  position: absolute;
                  right: 10px;
                  bottom: 5px;
                  font-size: 12px;
                  color: #666;
                }
              }
              .el-image {
                flex-shrink: 0;
                border-radius: 5px;
              }
            }
          }
        }
        .tag-container {
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          padding-top: 20px;
          .tag {
            position: relative;
            display: inline-flex;
            align-items: center;
            height: 36px;
            padding: 0 15px;
            margin-right: 10px;
            cursor: pointer;
            color: #2488ef;
            background-color: #fff;
            border-radius: 20px;
            font-size: 16px;
            user-select: none;
            strong {
              display: inline-flex;
              align-items: center;
              height: 100%;
              padding-right: 4px;
              .el-icon-plus {
                font-weight: bold;
              }
            }
          }
        }
      }
    }
  }
  .clue-box {
    padding: 20px 20px;
    margin-bottom: 20px;
    background-color: #fff;
    border-radius: 5px;
    .share-title {
      display: flex;
      align-items: center;
      margin-bottom: 25px;
      font-weight: bold;
      font-size: 16px;
      color: #333333;
      /deep/ .el-divider {
        width: 3px;
        background-color: #1978ff;
      }
    }
    .radio-box {
      margin-bottom: 20px;
    }
    .clue-qrcode {
      padding: 8px 15px;
      border: 1px dashed #ddd;
      border-radius: 5px;
    }
  }

  .share-btns {
    position: sticky;
    bottom: 0;
    display: flex;
    justify-content: flex-start;
    width: 100%;
    padding: 15px 30px;
    background: #fff;
    border-top: 1px solid #ddd;
  }
}
</style>
